import { DefaultButton } from '@fluentui/react/lib/Button';
import type { IIconProps } from '@fluentui/react/lib/Icon';
import { changeSplitViewMode } from 'owa-calendar-module-commanding';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import { FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc from 'owa-localize';
import * as React from 'react';
import {
    toggleDeclinedMeetingsViewText,
    toggleSplitViewText,
} from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';
import {
    shouldShowDeclinedEvents,
    toggleShowDeclinedEventsMode,
} from 'owa-show-declined-meetings-user-config';
import {
    shouldDisableSplitView,
    getSplitViewButtonTooltip,
} from 'owa-calendar-module-commanding-utils';

const styles = require('../../components/CalendarModuleCommandBar.scss');
const classNames = require('classnames');

export function getSurfaceConfigMenuItems(): FilterableMenuItem[] {
    const getSplitViewButton = (
        splitViewCheckToggleIcon: IIconProps,
        splitViewDisabled: boolean
    ) => () => {
        return (
            <DefaultButton
                className={styles.viewMenuButton}
                onClick={changeSplitViewMode}
                iconProps={splitViewCheckToggleIcon}
                disabled={splitViewDisabled}
                text={loc(toggleSplitViewText)}
                ariaLabel={loc(toggleSplitViewText)}
                styles={{
                    label: styles.viewMenuButtonLabel,
                }}
            />
        );
    };

    const splitViewDisabled = shouldDisableSplitView();
    const splitViewCheckToggleIcon = {
        // passing a space instead of an empty string because of a bug in fabric https://github.com/microsoft/fluentui/issues/12425
        iconName: getSurfaceStore().isInSplitView ? ControlIcons.CheckMark : ' ',
        className: classNames(styles.viewMenuIcon, {
            [styles.viewMenuButtonDisabled]: splitViewDisabled,
        }),
    };

    const configMenuItems = [
        new FilterableMenuItem({
            [FilterableMenuItemArgs.key]: 'SplitViewDivider',
            [FilterableMenuItemArgs.name]: '-',
        }),
        new FilterableMenuItem({
            [FilterableMenuItemArgs.key]: 'SplitView',
            [FilterableMenuItemArgs.onRender]: getSplitViewButton(
                splitViewCheckToggleIcon,
                splitViewDisabled
            ),
            [FilterableMenuItemArgs.title]: getSplitViewButtonTooltip(),
        }),
    ];

    if (isFeatureEnabled('cal-surface-declinedMeetings')) {
        const toggleDeclinedEventsSetting = () => {
            toggleShowDeclinedEventsMode(
                !shouldShowDeclinedEvents(),
                getSurfaceStore().dateRangeType
            );
        };

        const getShowDeclinedEventsButton = (checkToggleIcon: IIconProps) => () => {
            return (
                <DefaultButton
                    className={styles.viewMenuButton}
                    onClick={toggleDeclinedEventsSetting}
                    iconProps={checkToggleIcon}
                    text={loc(toggleDeclinedMeetingsViewText)}
                    ariaLabel={loc(toggleDeclinedMeetingsViewText)}
                    styles={{
                        label: styles.viewMenuButtonLabel,
                    }}
                />
            );
        };

        const declinedEventsCheckToggleIcon = {
            // passing a space instead of an empty string because of a bug in fabric https://github.com/microsoft/fluentui/issues/12425
            iconName: shouldShowDeclinedEvents() ? ControlIcons.CheckMark : ' ',
            className: styles.viewMenuIcon,
        };

        configMenuItems.push(
            new FilterableMenuItem({
                [FilterableMenuItemArgs.key]: 'ShowDeclinedEvents',
                [FilterableMenuItemArgs.onRender]: getShowDeclinedEventsButton(
                    declinedEventsCheckToggleIcon
                ),
                [FilterableMenuItemArgs.title]: loc(toggleDeclinedMeetingsViewText),
            })
        );
    }

    return configMenuItems;
}
